/**
 * @class Calle
 * @namespace usig
 * @constructor
 * @param {Integer} cod Codigo de calle
 * @param {String} nom Nombre oficial de la calle
 * @param {Array} alturas (optional) Array conteniendo los rangos de altura validos para esta calle
 * @param {Array} cruces (optional) Array conteniendo los id de las calles que se cruzan con esta
 */

const TIPO = "CALLE";
export default {
	construirCalle: (cod, nom) => {
		return {
			codigo: cod,
			nombre: nom,
			tipo: TIPO,
			toString: nom
		}
	},
}


// WEBPACK FOOTER //
// ./src/Calle.js